import { CSSProperties } from 'react';

export const container: CSSProperties = {
  backgroundColor: '#FB3B48',
  position: 'relative',
  width: '100%',
};

export const body: CSSProperties = {
  position: 'relative',
  margin: 'auto',
  width: 360,
  zIndex: 100,
};

export const botDee: CSSProperties = {
  backgroundColor: '#FFDF00',
  bottom: 0,
  height: 4,
  left: 0,
  position: 'absolute',
  right: 0,
  zIndex: 10,
};
